import { render, staticRenderFns } from "./Firmao.vue?vue&type=template&id=06c4b3a2&scoped=true"
import script from "./Firmao.vue?vue&type=script&lang=js"
export * from "./Firmao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4b3a2",
  null
  
)

export default component.exports